import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { LocaleConfigContext } from '../../../contexts/locale-config/locale-config';

import phoneIcon from '../../../../public/static/icons/handset.svg';
import emailIcon from '../../../../public/static/icons/email.svg';
import userIcon from '../../../../public/static/icons/user.svg';
import arrowLeft from '../../../../public/static/icons/arrowLeftAlternative.svg';

import {
    StyledContactFormHeader,
    StyledContactDirectly,
    StyledContactRow,
    StyledContactIcon,
} from './ship-contact-form.style';
import { __ } from '../../../utils/translation-service';

const ContactDirectlyLink = ({
    title,
    linkTitle,
    link,
}: {
    title: string;
    linkTitle: string;
    link: string;
}) => (
    <Box sx={{ marginLeft: '16px', lineHeight: '24px' }}>
        <Typography variant="body1" sx={{ fontSize: '16px', fontWeight: '700', mb: '4px' }}>
            {title}
        </Typography>
        <Box
            component={'a'}
            href={link}
            sx={{
                fontSize: '16px',
                color: '#fff',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                '&:hover, &:focus': {
                    color: '#fff',
                },
            }}
        >
            {linkTitle}
            <SvgIcon
                inheritViewBox
                component={arrowLeft}
                sx={{
                    width: '12px',
                    color: '#fff',
                    transform: 'rotate(180deg)',
                    marginLeft: '4px',
                }}
            />
        </Box>
    </Box>
);

export const ContactDirectlyBlock = () => {
    const { phoneNumber, slugs, url } = React.useContext(LocaleConfigContext);
    const expertUrl = `https://www.${url}/${slugs.contact}`;

    return (
        <StyledContactDirectly>
            <StyledContactFormHeader>{__('shipContactForm.contactUs')}</StyledContactFormHeader>

            <StyledContactRow>
                <StyledContactIcon>
                    <SvgIcon inheritViewBox component={phoneIcon} />
                </StyledContactIcon>

                <ContactDirectlyLink
                    title={__('shipContactForm.callToUs')}
                    linkTitle={phoneNumber}
                    link={`tel:${phoneNumber}`}
                />
            </StyledContactRow>

            <StyledContactRow>
                <StyledContactIcon>
                    <SvgIcon inheritViewBox component={emailIcon} />
                </StyledContactIcon>
                <ContactDirectlyLink
                    title={__('shipContactForm.writeAnEmail')}
                    linkTitle={__('infoEmail')}
                    link={`mailto:${__('infoEmail')}`}
                />
            </StyledContactRow>

            <StyledContactRow>
                <StyledContactIcon>
                    <SvgIcon inheritViewBox component={userIcon} />
                </StyledContactIcon>
                <ContactDirectlyLink
                    title={__('shipContactForm.getInTouch')}
                    linkTitle={__('shipContactForm.selectExpert')}
                    link={expertUrl}
                />
            </StyledContactRow>
        </StyledContactDirectly>
    );
};
